import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Cases from './pages/Cases';
import CaseDetail from './pages/CaseDetail';
import Pipeline from './pages/Pipeline';
import Tasks from './pages/Tasks';
import Commission from './pages/Commission';
import Analytics from './pages/Analytics';
import Documents from './pages/Documents';
import Export from './pages/Export';
import Reports from './pages/Reports';
import Referrals from './pages/Referrals';
import MortgageCalculator from './pages/MortgageCalculator';
import Suitability from './pages/Suitability';
import LenderPortals from './pages/LenderPortals';
import Milestones from './pages/Milestones';
import HeatMap from './pages/HeatMap';
import YearInReview from './pages/YearInReview';
import BankStatements from './pages/BankStatements';
import './App.css';
import { DarkModeProvider } from './context/DarkModeContext';

// Router component that handles auth callback detection
const AppRouter = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <ProtectedRoute>
            <Layout>
              <Clients />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/clients/:clientId"
        element={
          <ProtectedRoute>
            <Layout>
              <ClientDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases"
        element={
          <ProtectedRoute>
            <Layout>
              <Cases />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:caseId"
        element={
          <ProtectedRoute>
            <Layout>
              <CaseDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pipeline"
        element={
          <ProtectedRoute>
            <Layout>
              <Pipeline />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <ProtectedRoute>
            <Layout>
              <Tasks />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/commission"
        element={
          <ProtectedRoute>
            <Layout>
              <Commission />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytics"
        element={
          <ProtectedRoute>
            <Layout>
              <Analytics />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <Layout>
              <Documents />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/referrals"
        element={
          <ProtectedRoute>
            <Layout>
              <Referrals />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute>
            <Layout>
              <Reports />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/export"
        element={
          <ProtectedRoute>
            <Layout>
              <Export />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/calculator"
        element={
          <ProtectedRoute>
            <Layout>
              <MortgageCalculator />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/suitability"
        element={
          <ProtectedRoute>
            <Layout>
              <Suitability />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/portals"
        element={
          <ProtectedRoute>
            <Layout>
              <LenderPortals />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/milestones"
        element={
          <ProtectedRoute>
            <Layout>
              <Milestones />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/heatmap"
        element={
          <ProtectedRoute>
            <Layout>
              <HeatMap />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/year-in-review"
        element={
          <ProtectedRoute>
            <Layout>
              <YearInReview />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bank-statements"
        element={
          <ProtectedRoute>
            <Layout>
              <BankStatements />
            </Layout>
          </ProtectedRoute>
        }
      />
      
      {/* Redirect root to dashboard or login */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DarkModeProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </DarkModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
